import relatoriosPesquisaSatisfacao from '../services/relatoriosPesquisaSatisfacaoHttpService'
import { GET_ALL_PESQUISAS_SATISFACAO, GET_ALL_TAGS } from './mutation-types'

export default {
  listarPesquisasSatisfacao: async ({ commit }) => {
    try {
      const response = await relatoriosPesquisaSatisfacao.getPesquisasSatisfacao()
      commit(GET_ALL_PESQUISAS_SATISFACAO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarTags: async ({ commit }) => {
    try {
      const response = await relatoriosPesquisaSatisfacao.getTags()
      commit(GET_ALL_TAGS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
